import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { SystemParameterListResp } from 'domain/payload/response/systemParameter/SystemParameterListResp';
import { SystemParameterDetailResp } from 'domain/payload/response/systemParameter/SystemParameterDetailResp';
import { SystemParameterCreateReq } from 'domain/payload/request/systemParameter/SystemParameterCreateReq';
import { SystemParameterUpdateReq } from 'domain/payload/request/systemParameter/SystemParameterUpdateReq';

const SystemParameterService = () => {
  const systemParameterList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<SystemParameterListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/system-parameter/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const systemParameterDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<SystemParameterDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/system-parameter/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const systemParameterCreate = async (
    token: string,
    request: SystemParameterCreateReq
  ): Promise<BaseResponse<SystemParameterDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/system-parameter/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const systemParameterUpdate = async (
    token: string,
    request: SystemParameterUpdateReq
  ): Promise<BaseResponse<SystemParameterDetailResp>> => {
    try {
      console.log("Final payload:", JSON.stringify(request, null, 2));
      const response = await axiosInstance.put(`/v1/legacy/cms/system-parameter/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const systemParameterDelete = async (
    token: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/system-parameter/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { systemParameterList, systemParameterDetail, systemParameterCreate, systemParameterUpdate, systemParameterDelete };
};

export default SystemParameterService;